export default "__VITE_ASSET__CufnWwx___"